import api from './api';
import { User, LoginRequest, RegisterRequest, AuthResponse } from '../types';

export const authService = {
  async login(credentials: LoginRequest) {
    return api.post<AuthResponse>('/auth/login', credentials);
  },

  async register(data: RegisterRequest) {
    return api.post<AuthResponse>('/auth/register', data);
  },

  async logout() {
    return api.post('/auth/logout');
  },

  async getProfile() {
    return api.get<User>('/user/profile');
  },

  async updateProfile(data: Partial<User>) {
    return api.put<User>('/user/profile', data);
  },

  // F6 — Telegram-delivered password reset.
  async forgotPassword(email: string) {
    return api.post<{ success: boolean; message: string }>('/auth/forgot-password', { email });
  },

  async resetPassword(email: string, code: string, newPassword: string) {
    return api.post<{ success: boolean; message: string }>('/auth/reset-password', { email, code, newPassword });
  },

  // CL1-CL3 / F4 — record legal acceptance for the signed-in user.
  async acceptLegal() {
    return api.post<{ success: boolean; legalAccepted: boolean; legalVersion: string }>('/auth/accept-legal');
  },
};
